import axios from 'axios'
import { setContext } from '@apollo/client/link/context'
import { CookieName, getCookie } from '@src/helpers/cookie'
import { extractRealmSettingsFromURL, injectRealmSettings } from '@src/utilities/mockedRealmSettings'
import { createHttpLink } from '@apollo/client'
import { gettingStartedModuleApiFactory } from '@src/api/modules/pegasus/getting-started-module'
import { topicsExportApiFactory } from '@src/api/modules/phoenix/topicsExport'
import { connectorsWidgetApiFactory } from './modules/pegasus/connectors-widget'
import { vsmWelcomeWidgetApiFactory } from './modules/pegasus/vsm-welcome-widget'
import { addAxiosInterceptors } from '.'
import {
  expertSearchesApiFactory,
  homepageModulesApiFactory,
  onboardingDialogApiFactory,
  researchParticipationUsersApiFactory,
  savedFiltersApiFactory,
  searchApiFactory,
  translationApiFactory,
  versionApiFactory,
  userGraphqlApiFactory,
  termsGraphQlApiFactory,
  inviteUserCreationGraphQlApiFactory,
  usersApiFactory,
  networkLogoApiFactory,
  questionsApiFactory,
  phoenixPersonalisationApiFactory,
  settingsApiFactory,
  settingsAdminApiFactory,
  dismissedExpertiseFeedbackApiFactory,
  sortingPreferenceApiFactory,
  ulfShieldExpertsApiFactory,
  personalisationApiFactory,
  entitiesApiFactory,
  conceptsApiFactory,
  notificationsApiFactory,
  careersApiFactory,
  connectorsApiFactory,
  userProjectsApiFactory,
  cannyApiFactory,
  questionsImportApiFactory,
  questionsExportApiFactory,
  usersExportApiFactory,
  gamificationExportApiFactory,
  contextMessageApiFactory,
  userImportApiFactory,
  conceptAlertFactory,
  homepageContributionsApiFactory,
  profileBannerApiFactory,
  pinnedKnowledgeSpacesApiFactory,
  sessionActivitiesApiFactory,
  sessionsApiFactory,
  questionEvaluatorApiFactory,
  keaMessageVotesApiFactory
} from './modules'

const api = addAxiosInterceptors(axios.create())
const apiWithoutToken = axios.create()

const apolloLink = setContext((_, { headers }) => {
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      Authorization: `Bearer ${getCookie(CookieName.API_TOKEN)}`
    }
  }
}).concat(createHttpLink({
  uri: '/accounts/api/v1/graphql',
  fetch
}))

export const expertSearchesApi = expertSearchesApiFactory(api)
export const homepageModulesApi = homepageModulesApiFactory(api)
export const sortingPreferenceApi = sortingPreferenceApiFactory(api)
export const onboardingDialogApi = onboardingDialogApiFactory(api)
export const gettingStartedModuleApi = gettingStartedModuleApiFactory(api)
export const savedFiltersApi = savedFiltersApiFactory(api)
export const translationApi = translationApiFactory(apiWithoutToken)
export const versionApi = versionApiFactory(api)
export const researchParticipationUsersApi = researchParticipationUsersApiFactory(api)
export const searchApi = searchApiFactory(api)
export const userGraphQlApi = userGraphqlApiFactory(apolloLink)
export const termsGraphQlApi = termsGraphQlApiFactory(apolloLink)
export const inviteUserCreationGraphQlApi = inviteUserCreationGraphQlApiFactory(apolloLink)
export const usersApi = usersApiFactory(api, { overrideFirstSeenForCurrentUser: new URLSearchParams(window.location.search).has('i-am-new') })
export const questionsApi = questionsApiFactory(api)
export const phoenixPersonalisationApi = phoenixPersonalisationApiFactory(api)
export const dismissedExpertiseFeedbackApi = dismissedExpertiseFeedbackApiFactory(api)
export const ulfShieldExpertsApi = ulfShieldExpertsApiFactory(api).extend(userGraphQlApi)
export const personalisationApi = personalisationApiFactory(api)
export const entitiesApi = entitiesApiFactory(api)
export const conceptsApi = conceptsApiFactory(api)
export const connectorsApi = connectorsApiFactory(api)
export const notificationsV2Api = notificationsApiFactory(api)
export const userProjectsApi = userProjectsApiFactory(api)
export const careersApi = careersApiFactory(api)
export const networkLogoApi = networkLogoApiFactory(api)
export const cannyApi = cannyApiFactory(api)
export const questionsImportApi = questionsImportApiFactory(api)
export const questionsExportApi = questionsExportApiFactory(api)
export const topicsExportApi = topicsExportApiFactory(api)
export const usersExportApi = usersExportApiFactory(api)
export const gamificationExportApi = gamificationExportApiFactory(api)
export const contextMessageApi = contextMessageApiFactory(api)
export const userImportApi = userImportApiFactory(api)
export const conceptAlertApi = conceptAlertFactory(api)
export const homepageContributionsApi = homepageContributionsApiFactory(api)
export const connectorsWidgetApi = connectorsWidgetApiFactory(api)
export const vsmWelcomeWidgetApi = vsmWelcomeWidgetApiFactory(api)
export const profileBannerApi = profileBannerApiFactory(api)
export const pinnedKnowledgeSpacesApi = pinnedKnowledgeSpacesApiFactory(api)
export const sessionActivitiesApi = sessionActivitiesApiFactory(api)
export const sessionsApi = sessionsApiFactory(api)
export const questionEvaluatorApi = questionEvaluatorApiFactory(api)
export const keaMessageVotesApi = keaMessageVotesApiFactory(api)

export const realmSettingsApi = {
  ...settingsApiFactory(api, {
    staticSettings: (window as any).REALM_SETTINGS,
    postProcessSettings(settings) {
      if (window.location.search) {
        return injectRealmSettings(settings, extractRealmSettingsFromURL(window.location.search))
      }
      return settings
    }
  }),
  ...settingsAdminApiFactory(api, {
    userGraphQlApi
  })
}
